/**
 * Zod schema for the 患者情報検索 search form.
 * Mirrors backend PatientSearchListRequest validation rules.
 */

import { z } from 'zod';

const searchDuration = z.union([z.literal(0), z.literal(1), z.literal(2)]);
const birthDuration = z.union([z.literal(0), z.literal(1), z.literal(2)]);
const sortRadio = z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)]);
const binaryFlag = z.union([z.literal(0), z.literal(1)]);
const yearmonth = z
  .string()
  .regex(/^\d{6}$/, '年月は6桁(YYYYMM)で入力してください。')
  .or(z.literal(''));

export const searchPatientListSchema = z
  .object({
    visit_from_yearmonth: yearmonth.optional().default(''),
    visit_to_yearmonth: yearmonth.optional().default(''),
    search_duration: searchDuration.default(0),
    insurer_type_id: z.array(z.number().int().positive()).default([]),
    from_age: z.number().int().min(0).max(999).nullable().optional(),
    to_age: z.number().int().min(0).max(999).nullable().optional(),
    birth_month: z.number().int().min(0).max(12).default(0),
    birth_duration: birthDuration.default(0),
    sex_id: z.number().int().positive().nullable().optional(),
    has_spouse: binaryFlag.nullable().optional(),
    has_children: binaryFlag.nullable().optional(),
    address: z.string().max(255).default(''),
    free_words: z.string().max(255).default(''),
    dm_reason_type_id: z.array(z.number().int().positive()).default([]),
    dm: z.boolean().default(false),
    include: z.boolean().default(false),
    sort_radio: sortRadio.default(0),
  })
  .refine(
    v =>
      v.from_age == null ||
      v.to_age == null ||
      v.to_age >= v.from_age,
    { message: '年齢(上限)は年齢(下限)以上にしてください。', path: ['to_age'] }
  )
  .refine(
    v =>
      !v.visit_from_yearmonth ||
      !v.visit_to_yearmonth ||
      v.visit_to_yearmonth >= v.visit_from_yearmonth,
    {
      message: '施術期間終了月は開始月以降にしてください。',
      path: ['visit_to_yearmonth'],
    }
  );

export type SearchPatientListFormValues = z.infer<typeof searchPatientListSchema>;
